var React = require('react');

function Doctor (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.625 5.5V4.25C13.625 3.91848 13.4933 3.60054 13.2589 3.36612C13.0245 3.1317 12.7065 3 12.375 3H8.625C8.29348 3 7.97554 3.1317 7.74112 3.36612C7.5067 3.60054 7.375 3.91848 7.375 4.25V5.5M10.5 8.9375V13.3125M12.6875 11.125H8.3125M3.625 5.5H17.375C17.7202 5.5 18 5.77982 18 6.125V16.125C18 16.4702 17.7202 16.75 17.375 16.75H3.625C3.27982 16.75 3 16.4702 3 16.125V6.125C3 5.77982 3.27982 5.5 3.625 5.5Z","stroke":"#22202F","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Doctor.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Doctor;

Doctor.default = Doctor;
